var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03831 7.03831L0.788307 13.2883C0.699448 13.3711 0.58192 13.4162 0.460481 13.414C0.339043 13.4119 0.223177 13.3627 0.137294 13.2768C0.0514111 13.1909 0.00221566 13.0751 7.30287e-05 12.9536C-0.00206961 12.8322 0.0430078 12.7147 0.125808 12.6258L6.04378 6.70706L0.125808 0.788307C0.0430078 0.699448 -0.00206961 0.581919 7.30287e-05 0.460481C0.00221566 0.339043 0.0514111 0.223177 0.137294 0.137294C0.223177 0.0514105 0.339043 0.00221566 0.460481 7.30296e-05C0.58192 -0.00206961 0.699448 0.0430072 0.788307 0.125807L7.03831 6.37581C7.12609 6.4637 7.1754 6.58284 7.1754 6.70706C7.1754 6.83128 7.12609 6.95042 7.03831 7.03831Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.c7de036eb42fd098c4f0790c36754b41.svg";
export { ForwardRef as ReactComponent };